import { render } from "./AccountsSelect.vue?vue&type=template&id=4516fa4e"
import script from "./AccountsSelect.vue?vue&type=script&lang=js"
export * from "./AccountsSelect.vue?vue&type=script&lang=js"
script.render = render

export default script